import React from "react";
import PropTypes from "prop-types";

// Icons
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";

// Colors
import green from "@material-ui/core/colors/green";
import red from "@material-ui/core/colors/red";

const checkedStyleYes = { padding: 3, color: green[700] };
const checkedStyleNo = { padding: 3, color: red[700] };

const EnabledFeature = ({ toEvaluate }) => {
  return toEvaluate ? (
    <CheckIcon style={checkedStyleYes} />
  ) : (
    <CloseIcon style={checkedStyleNo} />
  );
};

EnabledFeature.propTypes = {
  toEvaluate: PropTypes.bool.isRequired,
};

export default EnabledFeature;
